<template>
    <div class="product-item">
        <a :href="product.url || url" :title="product.title">
            <div class="product-item__image">
                <img v-if="product.images.length" :data-src="product.images[0] | imageSize('500x')" :alt="product.title" class="product-item__image lazyload"/>
                <slot v-else name="placeholder-image"></slot>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    props: [
        'product',
        'translations'
    ],

    data() {
        return {
            url: null
        }
    },

    computed: {
        isSale() {
            return this.product.compare_at_price && this.product.price < this.product.compare_at_price;
        }  
    },

    created() {
        if (!this.product.url) {
            this.url = `/products/${this.product.handle}`;
        }
    }
}
</script>